import React from 'react';
import { ButtonGroup, Button } from '@mui/material';

export const WAREHOUSE_SELECTED_LOCATION_KEY = 'warehouseSelectedLocation';

export type WarehouseLocation = 'tampa' | 'pittsburgh';

const LOCATIONS: { value: WarehouseLocation; label: string }[] = [
  { value: 'pittsburgh', label: 'Pittsburgh' },
  { value: 'tampa', label: 'Tampa' },
];

export function getWarehouseSelectedLocation(): WarehouseLocation {
  const stored = sessionStorage.getItem(WAREHOUSE_SELECTED_LOCATION_KEY);
  if (stored === 'pittsburgh' || stored === 'tampa') return stored;
  return 'pittsburgh';
}

/**
 * Location toggle for top navigation bar (Warehouse module).
 * Pittsburgh and Tampa are separate physical ServMan databases, and the same PO number can exist
 * in both — every lookup is only meaningful paired with the location selected here.
 * Matches CollectionsLocationToggle styling; uses a dedicated session key.
 */
const WarehouseLocationToggle: React.FC = () => {
  const selectedLocation = getWarehouseSelectedLocation();

  const handleLocationChange = (location: WarehouseLocation) => {
    sessionStorage.setItem(WAREHOUSE_SELECTED_LOCATION_KEY, location);
    window.location.reload();
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span
        style={{
          fontSize: '13px',
          fontWeight: 600,
          color: '#202223',
          whiteSpace: 'nowrap',
        }}
      >
        Location:
      </span>
      <ButtonGroup size="small" variant="outlined">
        {LOCATIONS.map(({ value, label }) => (
          <Button
            key={value}
            variant={selectedLocation === value ? 'contained' : 'outlined'}
            onClick={() => handleLocationChange(value)}
            style={{
              textTransform: 'none',
              minWidth: '90px',
            }}
          >
            {label}
          </Button>
        ))}
      </ButtonGroup>
    </div>
  );
};

export default WarehouseLocationToggle;
